import React, { useContext, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Prompt } from 'react-router';
import { Modal, Button } from 'antd';
import { unsavedThresholdSelector } from '@store/noc/base/selectors';
import { saveAndRedirectThreshold } from '@store/noc/threshold/actions';
import { updateThresholdChangeStatus } from '@store/noc/base/actions';
import { NOC_URL, unsavedChangesTextObj } from '@components/noc-metric-panel/utils/constants';
import ParentContext from 'pages/Noc/Threshold/context';

const PromptModal = ({
  showUnsavedDataWarning,
  setShowUnsavedDataWarning,
}: {
  showUnsavedDataWarning: boolean;
  setShowUnsavedDataWarning: (show: boolean) => void;
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { thresholdConfig, reset, hasError } = useContext(ParentContext);

  const unsavedChanges = useSelector(unsavedThresholdSelector);

  useEffect(() => {
    const changeInProgress =
      !isEmpty(thresholdConfig.threshold_baseline) || !isEmpty(thresholdConfig.thresholds);
    dispatch(updateThresholdChangeStatus(changeInProgress));
  }, [thresholdConfig, dispatch]);

  const onOk = () => {
    setShowUnsavedDataWarning(false);
    dispatch(saveAndRedirectThreshold(thresholdConfig, history, reset));
  };

  const onCancel = () => {
    setShowUnsavedDataWarning(false);
  };

  const onDiscard = () => {
    setShowUnsavedDataWarning(false);
    dispatch(updateThresholdChangeStatus(false));
    reset();
    setTimeout(() => {
      history.push(NOC_URL);
    }, 0);
  };

  const footerButtons = [
    <Button key="discard" onClick={onDiscard}>
      Discard
    </Button>,
    <Button key="save" type="primary" onClick={onOk} disabled={hasError}>
      Save
    </Button>,
  ];

  const showModal = () => {
    setShowUnsavedDataWarning(true);
    return !unsavedChanges;
  };

  return (
    <>
      <Prompt when={unsavedChanges} message={showModal} />
      <Modal
        title={unsavedChangesTextObj.title}
        open={showUnsavedDataWarning}
        onCancel={onCancel}
        footer={footerButtons}
      >
        <p>{unsavedChangesTextObj.text}</p>
      </Modal>
    </>
  );
};

export default PromptModal;
